import * as AdditionalServiceWrapper from './components/AdditionalServiceWrapper.css';
import * as SegmentCollapse from './components/SegmentCollapse/SegmentCollapse.css';
export default {
    AdditionalServiceWrapper,
    SegmentCollapse
};
